import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'disableViews'
})
export class DisableViewsPipe implements PipeTransform {

  transform(value: any[], user): any[] {
    if(user?.rolId === 4){
      value = [
        {
          icon: './assets/iconsAdmin/prod.svg',
          route: '/admin/products',
          text: 'Productos'
        },
        {
          icon: './assets/iconsAdmin/pagos.svg',
          route: '/admin/paylist',
          text: 'Pagos'
        },
      ]
      value.push({
        icon: './assets/iconsAdmin/salir.svg',
        route: '/home',
        text: 'Salir'
      })
    }

    return value;
  }

}
